import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { alarmClock, plus, ReactSvg } from '../../../../shared/vector-images';

interface AddReminderItemProps {
  type: string;
  label: string;
  action: (type: string) => void;
  icon?: React.ReactNode;
  description?: string;
  className?: string;
}

const AddReminderItem: FC<AddReminderItemProps> = ({
  type,
  label,
  action,
  icon,
  description,
  className,
}) => {
  const theme = useTheme();

  const handleAdd = (addType: string) => {
    action(addType);
  };

  return (
    <Box
      bg="white"
      p={2}
      borderRadius={10}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      onClick={() => handleAdd(type)}
      className={className}
    >
      <Box
        width={40}
        height={40}
        mr={3}
        display="flex"
        flex="0 0 auto"
        justifyContent="center"
        alignItems="center"
        borderRadius="50%"
        bg={theme.colors.secondarylight}
      >
        <Box width={24} height={24} flex="0 0 24px">
          {icon || (
            <ReactSvg
              toDisplay={alarmClock()}
              options={{
                fillColor: theme.colors.secondary,
              }}
              width={24}
              height={24}
            />
          )}
        </Box>
      </Box>
      <Box flex="1 1 auto">
        <Box>{label}</Box>
        {description && (
          <Box fontSize="1" color="darkergrey" mt={1}>
            {description}
          </Box>
        )}
      </Box>
      <Box display="flex" flex="0 0 40px" justifyContent="center" ml={2}>
        <ReactSvg
          toDisplay={plus()}
          options={{
            fillColor: theme.colors.primary,
          }}
          width={36}
          height={36}
        />
      </Box>
    </Box>
  );
};

AddReminderItem.defaultProps = {
  icon: undefined,
  description: undefined,
  className: undefined,
};

export default AddReminderItem;
